export const slideWidthPx = 98;
export const singleAnswerWidthPx = 200;
export const minTableWidthPx = 880;
export const minQuestionWidthPx = 600;
export const tableSpacingWidthPx = 96;
